import { inject, Injectable, signal } from '@angular/core';
import { EngagementDetails } from '@interfaces';
import { FuncService } from "../../../../services";

@Injectable({
	providedIn: 'root'
})
export class EngagementViewerDialogService {

	private func = inject(FuncService);
	engagementDetails = signal<EngagementDetails | undefined>(undefined);

	public async getEngagementDetails(engagementId: number) {
		const response = await this.func.engagement.getEngagementById({ engagementId });
		if (response) {
			this.engagementDetails.set(response);
		}
	}

	public async deleteEngagementInteraction(engagementId: number, engagementContactId: number) {
		const interaction = await this.func.engagement.interaction.remove({ engagementId, engagementContactId });
		return interaction;
	}

	public async closeEngagement(engagementId: number) {
		await this.func.engagement.closeEngagement({ engagementId });
	}

	public async reOpenEngagement(engagementId: number) {
		await this.func.engagement.reopenEngagement({ engagementId });
	}
}